import { BannerSlide } from '../types';

export const DEFAULT_BANNER_SLIDES: BannerSlide[] = [
  {
    id: 'banner-lecithin',
    title: 'กิฟฟารีน เลซิติน (60 แคปซูล)',
    subtitle: 'เลซิติน ผสมแคโรทีนอยด์ และวิตามิน อี ดูแลตับ บำรุงสมอง และหลอดเลือดหัวใจ นวัตกรรมยอดนิยมอันดับ 1',
    badge: 'GIFFARINE LECITHIN',
    productCode: '82023',
    price: 680,
    memberPrice: 510,
    pv: 510,
    imageUrl: '/products/photoroom-lecithin.png',
    bgGradient: 'from-[#FFFBEB] via-[#FEF3C7] to-[#FFFFFF]',
    accentColor: '#D97706',
    buttonText: 'สั่งซื้อทันที',
    isActive: true,
    fitMode: 'contain',
    showTextOverlay: true,
  },
  {
    id: 'banner-1',
    title: 'พรีเมียม เอชพีอาร์ เรตินอยด์ สกิน บูสเตอร์',
    subtitle: 'เรตินอยด์ โดสถึง แบบไม่ทำร้ายผิว นวัตกรรม HPR Retinoid 0.2% เผยผิวกระจ่างใส อ่อนเยาว์',
    badge: 'HPR 0.2%',
    productCode: '84054',
    price: 780,
    memberPrice: 585,
    pv: 585,
    imageUrl: '/products/photoroom-hpr.png',
    bgGradient: 'from-[#FCE7F3] via-[#FDF2F8] to-[#FFFFFF]',
    accentColor: '#E60067',
    buttonText: 'สั่งซื้อทันที',
    isActive: true,
    fitMode: 'contain',
    showTextOverlay: true,
  },
  {
    id: 'banner-2',
    title: 'กิฟฟารีน รีจู โกลว์ ซีรั่ม (Reju Glow Serum)',
    subtitle: 'ผิวฉ่ำวาว อิ่มฟู สุขภาพดี ดูโกลว์ใส ผสานพลัง PDRN 5,000 ppm และ Natural Hydro Effect Complex',
    badge: 'PDRN 5,000 PPM',
    productCode: '84051',
    price: 1200,
    memberPrice: 900,
    pv: 900,
    imageUrl: '/products/photoroom-rejuglow.png',
    bgGradient: 'from-[#FFF1F2] via-[#FCE7F3] to-[#FFFFFF]',
    accentColor: '#E11D48',
    buttonText: 'สั่งซื้อทันที',
    isActive: true,
    fitMode: 'contain',
    showTextOverlay: true,
  },
  {
    id: 'banner-3',
    title: 'กิฟฟารีน ไฮยา อินเทนซีฟ ไวท์เทนนิ่ง พรี-ซีรั่ม',
    subtitle: 'ซีรั่มอันดับ 1 เพื่อผิวเด้ง เนียน นุ่ม ฉ่ำน้ำ ด้วยไฮยาลูรอนบริสุทธิ์ 100% จากเยอรมนี ผิวกระจ่างใสเรียบเนียน',
    badge: 'HYA PRE-SERUM',
    productCode: '84032',
    price: 600,
    memberPrice: 450,
    pv: 450,
    imageUrl: '/products/photoroom-hya.png',
    bgGradient: 'from-[#EFF6FF] via-[#DBEAFE] to-[#FFFFFF]',
    accentColor: '#2563EB',
    buttonText: 'สั่งซื้อทันที',
    isActive: true,
    fitMode: 'contain',
    showTextOverlay: true,
  },
];
